import { css, SerializedStyles } from '@emotion/react';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { baseDropdownStyle } from 'src/domains/layouts/webview/components/styles/baseDropdownStyle.style';





const setPaymentDropDown = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            &.custom-dropdown-select .react-select__control {

                border-radius: ${theme.star.radius.small};

            }

            &.custom-dropdown-select .react-select__menu {

                border-radius: ${theme.star.radius.small};

            }



            &.custom-dropdown-select .react-select__menu-list {

                border-radius: ${theme.star.radius.small};

            }

        `;

    }

    return css``;

};



export const paymentDropDown = (theme: EmotionTheme, newDropdown: boolean, variant: DefaultComponentVariantType | null): SerializedStyles => css`

    ${baseDropdownStyle(variant, theme)}

    ${setPaymentDropDown(variant, theme)}



    &.custom-dropdown-select .react-select__control {

        font-size: ${theme.star.fontSize.xRegular};

        line-height: ${theme.star.fontSize.xMedium};

        background: ${theme.star.form.light.bgColor};

        padding: 12px;

        height: 44px;

        border: 2px solid transparent;

    }



    &.custom-dropdown-select .react-select__control--is-focused {

        box-shadow: none;

    }



    &.custom-dropdown-select .react-select__control,

    &.custom-dropdown-select .react-select__option,

    &.custom-dropdown-select .react-select__placeholder {

        color: ${theme.star.form.txtColor};

        cursor: pointer;

    }



    &.custom-dropdown-select .react-select__option {

        border: none;

        font-size: ${theme.star.fontSize.xRegular};

        width: 100%;

        display: flex;

        justify-content: space-between;

        align-items: center;

        color: ${theme.star.paymentMethodDropdown.txtColor};

        padding: 12px 16px;

        background-color: ${theme.star.paymentMethodDropdown.bgColor};

        position: relative;

    }



    &.custom-dropdown-select .react-select__option:hover {

        ${newDropdown ? `

            &:not(.react-select__option--is-selected)::after {

              content: '';

              position: absolute;

              inset: 0;

              background-color: ${theme.star.paymentMethodDropdown.bgColorTertiary};

              pointer-events: none;

            }

          ` : `

              color: ${theme.star.paymentMethodDropdown.txtColorSecondary};

              background-color: ${theme.star.paymentMethodDropdown.bgColorSecondary};

          `}

    }



    &.custom-dropdown-select .react-select__option--is-disabled {

        color: ${theme.star.paymentMethodDropdown.txtColorTertiary};

    }



    &.custom-dropdown-select .react-select__control--menu-is-open {

        border: 2px solid ${theme.star.paymentMethodDropdown.borderColor};

    }



    &.custom-dropdown-select .react-select__control--menu-is-open > .react-select__indicators {

        transform: rotate(180deg);

    }



    &.custom-dropdown-select .react-select__menu {

        margin-top: 8px;

        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15), 0 4px 8px 3px rgba(0, 0, 0, 0.15);

    }



    &.custom-dropdown-select .react-select__option--is-selected {

        color: ${theme.star.paymentMethodDropdown.txtColorSenary};

        background-color: ${theme.star.paymentMethodDropdown.bgColorSenary};

    }



    &.custom-dropdown-select .react-select__value-container {

        display: flex;

        align-items: center;

    }

`;



